import actionTypes from './actionTypes';

export const stopAllCredits = () => ({
  type: actionTypes.STOP_ALL_CREDITS,
});

export const stoppedAllCredits = () => ({
  type: actionTypes.STOPPED_ALL_CREDITS,
});
